<button
  [matMenuTriggerData]="userMenuData"
  [matMenuTriggerFor]="menu"
  (click)="toggleDropdown()"
  [disabled]="disabled"
>
  <ng-container *ngIf="value"
    >{{ value?.bus.platform.name }} -
    <ng-container
      *ngIf="
        value.bus.platform.name !== 'ChatGPT镜像版' &&
        value.bus.platform.name !== '爆米花' &&
        value.bus.platform.name !== 'Midjourney镜像版' &&
        value.bus.platform.name !== 'Grok镜像版'
      "
      >{{ value.bus.bus_account?.username }}</ng-container
    >
  </ng-container>
  <ng-container *ngIf="!value">选择订阅的车票</ng-container>
  <img alt="arrow" width="20" height="20" [src]="src" />
</button>
<mat-menu #menu="matMenu" class="my-menu">
  <ng-template matMenuContent let-menuWidth="menuWidth">
    <div [style.width.px]="menuWidth">
      <button mat-menu-item *ngIf="seats.length === 0">没有数据</button>
      <button
        mat-menu-item
        *ngFor="let data of seats"
        (click)="selectOption(data)"
      >
        <span
          >{{ data.bus.platform.name }} -
          <ng-container
            *ngIf="
              data.bus.platform.name !== 'ChatGPT镜像版' &&
              data.bus.platform.name !== '爆米花' &&
              data.bus.platform.name !== 'Midjourney镜像版' &&
              data.bus.platform.name !== 'Grok镜像版'
            "
            >{{ data.bus.bus_account?.username }}</ng-container
          >
        </span>
      </button>
    </div>
  </ng-template>
</mat-menu>
